export default __webpack_public_path__ + "static/media/CivilEng_IMG-Seremban.8e1e6d76.png";